/**
 * Announcement Banner JS
 * -----------------------------------------------------------------------------
 *
 * All the JS for the Announcement Banner component.
 */

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {
    className: 'announcement-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      window.debounce = require( 'lodash/debounce' );

      const root = $( ':root' );

      function setAnnouncementBannerHeight() {
        const $banner = $( '#announcement-banner' );
        const isBannerVisible = $banner.is( ':visible' );
        const height = isBannerVisible ? $banner.outerHeight() : 0;
        root.css( '--announcementBannerHeight', `${height}px` );
      }

      function closeAnnouncementBanner() {
        $( '#announcement-banner' ).slideUp( 200, function() {
          setAnnouncementBannerHeight();
        } );
      }

      function openAnnouncementBanner() {
        $( '#announcement-banner' ).slideDown( 200, function() {
          setAnnouncementBannerHeight();
        } );
      }

      setAnnouncementBannerHeight();

      $( window ).on( 'resize', debounce( function() {
        setAnnouncementBannerHeight();
      }, 100 ) );

      if ( !sessionStorage.getItem( 'announcement-banner-seen' ) ) {
        sessionStorage.setItem( 'announcement-banner-seen', 'false' );
      }
      if ( sessionStorage.getItem( 'announcement-banner-seen' ) === 'false' ) {
        openAnnouncementBanner();
      }

      $( '#announcement-banner__close' ).on( 'click', function() {
        closeAnnouncementBanner();
        sessionStorage.setItem( 'announcement-banner-seen', 'true' );
      } );
    },
    finalize: function() {},
  };
  app.registerComponent( 'announcement-banner', COMPONENT );
} )( app );
